// The packets and panel-governance screens' words (lane B6): Kickoff & Packets, the panel-change request and the
// acknowledgment. Every entry quotes his glossary (the D0 label suites discover this module, a lane folder of
// src/views, and hold it to the same rules as src/mc). Words the design system already carries are imported from it
// where they are drawn, never redefined here. Each slice fills only its own block.

import { defineLabels, template } from "@/mc/labels/labels";

// ---- S12 · Kickoff & Packets (keys kickoff.*) ----
const KICKOFF_INCLUDES = "\"Email includes app access, packet links, assigned ROOTS/skills, interview guidance, 24-hour scorecard SLA, confidentiality and debrief expectations.\"";
const PANEL_EMAIL = "\"app sends one panel email to interviewers, HM, Recruiter and HRBP.\"";
export const KICKOFF_LABELS = /* @__PURE__ */ defineLabels({
  title: { text: "Kickoff & Packets" },
  packet: { text: "Packet" },
  round: { text: "Round" },
  blockRelease: { text: "Block release on incomplete coverage." },
  recruiterRelease: { text: "Recruiter release" },
  panelEmailTo: { text: "One panel email to interviewers, HM, Recruiter and HRBP." },
  kickoffEmail: { text: "Kickoff email" },
  panelAccess: { text: "Panel access" },
  interviewerOwnPacket: { text: "Interviewer sees only own packet." },
  packetLink: { text: "Packet link" },
  uniquePacketLinks: { text: "Unique authorized packet links work." },
  appAccess: { text: "App access" },
  assignedValuesSkills: { text: "Assigned values/skills" },
  skills: { text: "Skills" },
  packetLinks: { text: "Packet links" },
  interviewGuidance: { text: "Interview guidance" },
  scorecardSla: { text: "24-hour scorecard SLA" },
  confidentiality: { text: "Confidentiality" },
  debriefExpectations: { text: "Debrief expectations" },
});

// ---- S13 · Panel change and acknowledgment (keys change.*, ack.*) ----
// The panel-change slide-over and the review route (D17): his §10 words, each quoting the glossary line it is cut from.
const REVALIDATE = '"Revalidate five ROOTS values, required skills, interviewer ownership, scorecards and debrief coverage."';
const BLOCKED_ROW = '"Blocked — Coverage or data gap — Gap resolved"';
const APPROVED_ROW = '"Approved — All approvals complete — Regenerate packets/messages"';
const REJECTED_ROW = '"Rejected — Denied — Reason stored"';
const COMMUNICATED_ROW = '"Communicated — Notifications sent — Delivery recorded"';
const COMPLETED_ROW = '"Completed — Access/calendars/scorecards updated — All tasks closed"';
const RECRUITER_ROW = '"Pending Recruiter Review — Coverage/continuity review — Recruiter decision"';
const HM_ROW = '"Pending HM Review — Material panel structure change — HM decision"';
const DRAFT_ROW = '"Draft — Not submitted — Requester completes details"';
const ROUND_OBJECT = 'Object "InterviewRound"/"Round".';
const REMINDERS = '"50% reminder, near-breach urgent reminder, breach dashboard risk."';

export const CHANGE_LABELS = /* @__PURE__ */ defineLabels({
  round: { text: "Round" },
  requester: { text: "Requester" },
  revalidate: { text: "Revalidate" },
  checkRoots: { text: "Five ROOTS values" },
  checkSkills: { text: "Required skills" },
  checkOwnership: { text: "Interviewer ownership" },
  checkScorecards: { text: "Scorecards" },
  checkDebrief: { text: "Debrief coverage" },
  reject: { text: "Reject" },
  denied: { text: "Denied" },
  reasonStored: { text: "Reason stored" },
  coverageGap: { text: "Coverage or data gap" },
  gapResolved: { text: "Gap resolved" },
  allApprovalsComplete: { text: "All approvals complete" },
  regenerate: { text: "Regenerate packets/messages" },
  revokeAccess: { text: "Revoke removed interviewer access" },
  notificationsSent: { text: "Notifications sent" },
  deliveryRecorded: { text: "Delivery recorded" },
  accessUpdated: { text: "Access/calendars/scorecards updated" },
  allTasksClosed: { text: "All tasks closed" },
  coverageReview: { text: "Coverage/continuity review" },
  recruiterDecision: { text: "Recruiter decision" },
  hmDecision: { text: "HM decision" },
  notSubmitted: { text: "Not submitted" },
  reminder: { text: "50% reminder" },
  nearBreach: { text: "Near-breach urgent reminder" },
  breach: { text: "Breach dashboard risk" },
});

// The interviewer's own answer on their round row and the decline dialog (D6, D17).
const ACCEPT_DECLINE = '"Interviewers accept/decline."';
const DECLINE_OPENS = '"Decline opens panel-change workflow."';

export const ACK_LABELS = /* @__PURE__ */ defineLabels({
  interview: { text: "Interview" },
  interviewers: { text: "Interviewers" },
  declineOpens: { text: "Decline opens panel-change workflow." },
});

